import { PointerEvent } from 'react';
import {
  PointerSensor as DefaultPointerSensor,
  KeyboardSensor as DefaultKeyboardSensor,
  Activators,
  KeyboardSensorOptions,
} from '@wix/patterns-dnd-kit-core';
import { isDragHandleNode } from './DragHandle';

const allowedTags = new Set<string>(['tr', 'td']);
const blockedTags = new Set<string>([
  'button',
  'a',
  'select',
  'input',
  'option',
  'textarea',
  'img',
  'label',
]);
const blockedRoles = new Set<string>(['button', 'listbox']);

const shouldAllowDrag = (node: HTMLElement | null): boolean => {
  while (node) {
    const tagName = node.tagName.toLowerCase();
    const role = node.getAttribute('role');

    if (allowedTags.has(tagName)) {
      return true;
    }

    if (isDragHandleNode(node)) {
      return true;
    }

    if (blockedTags.has(tagName)) {
      return false;
    }

    if (role && blockedRoles.has(role)) {
      return false;
    }

    node = node.parentElement;
  }

  return false;
};

export class PointerSensor extends DefaultPointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: ({ nativeEvent: event }: PointerEvent) => {
        return shouldAllowDrag(event.target as HTMLElement);
      },
    },
  ];
}

export class KeyboardSensor extends DefaultKeyboardSensor {
  static activators: Activators<KeyboardSensorOptions> = [
    {
      eventName: 'onKeyDown' as const,
      handler: (event, options, context) => {
        return (
          shouldAllowDrag(event.nativeEvent.target as HTMLElement) &&
          DefaultKeyboardSensor.activators.every((activator) =>
            activator.handler(event, options, context),
          )
        );
      },
    },
  ];
}
